/* Swubie mobile sticky "Bestel nu" bar (markup + CSS: snippets/swubie-sticky-cta.liquid).
   Shows once the hero CTA has scrolled out of view. Hides while the buy box or the footer is
   on screen, and while the cookie banner or the cart drawer is open. Tapping scrolls to the
   buy box; there is no add to cart from the bar.
   Positions are measured on scroll (not with IntersectionObserver, whose callbacks proved
   unreliable on the product page). */
(function () {
  var bar = document.querySelector('.swb-sticky');
  if (!bar) return;
  var btn = bar.querySelector('.swb-sticky__btn');

  var box = document.querySelector('[id="aanbod"]') || document.querySelector('.slp-offer, .sv2');
  /* 50/50 offer test (assets/swubie-aanbod.js): the V2 product page holds the pack box and a
     hidden ladder; aim at the one that is shown. Pages without the test are unchanged. */
  var ladder = document.querySelector('.swl[data-swl-test]');
  if (ladder && ladder.getClientRects().length) {
    box = ladder;
    /* "vanaf" is the ladder's lowest price (2 bags), not the 100 pack */
    var from = ladder.getAttribute('data-swl-from');
    var priceEl = bar.querySelector('.swb-sticky__price');
    if (from && priceEl) priceEl.textContent = 'vanaf ' + from;
  }
  if (!box) return;
  /* Product page has no hero: the buy box itself is the first buy button */
  var hero = document.querySelector('.slp-hero .slp-btn-primary');
  var footer = document.querySelector('footer');

  function onScreen(el, margin) {
    var r = el.getBoundingClientRect();
    return r.bottom > margin && r.top < window.innerHeight - margin;
  }

  function blocked() {
    var pc = document.getElementById('shopify-pc__banner');
    if (pc && pc.offsetHeight > 0 && getComputedStyle(pc).visibility !== 'hidden') return true;
    var prefs = document.getElementById('shopify-pc__prefs');
    if (prefs && prefs.offsetHeight > 0) return true;
    var drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.classList.contains('active')) return true;
    return false;
  }

  function update() {
    /* Only after scrolling past the hero CTA, not while it is still below the fold */
    var beforeHero = hero && hero.getBoundingClientRect().bottom > 0;
    var hide = beforeHero || onScreen(box, 40) || (footer && onScreen(footer, 0)) || blocked();
    if (hide === bar.classList.contains('is-hidden')) return;
    bar.classList.toggle('is-hidden', hide);
    bar.setAttribute('aria-hidden', hide ? 'true' : 'false');
    btn.setAttribute('tabindex', hide ? '-1' : '0');
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { ticking = false; update(); });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  /* Cookie banner and cart drawer open and close without scrolling */
  setInterval(update, 700);

  btn.addEventListener('click', function (ev) {
    ev.preventDefault();
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish('swubie_sticky_click', { page: location.pathname });
      }
    } catch (err) {}
    var header = document.querySelector('.shopify-section-group-header-group header, header.header');
    var offset = header ? header.getBoundingClientRect().height : 0;
    var top = Math.max(0, box.getBoundingClientRect().top + window.pageYOffset - offset - 8);
    var from = window.pageYOffset;
    window.scrollTo({ top: top, behavior: 'smooth' });
    /* Fallback for browsers that ignore or stall a smooth scroll: jump if nothing moved */
    setTimeout(function () {
      if (Math.abs(window.pageYOffset - from) < 2) {
        document.documentElement.style.scrollBehavior = 'auto';
        window.scrollTo(0, top);
        document.documentElement.style.scrollBehavior = '';
      }
    }, 600);
  });

  update();
})();
